import { useCallback, useState, ReactNode } from 'react';

import {
  ActionList,
  Button,
  ButtonProps,
  Popover
} from '@shopify/polaris';

import {
  DeleteIcon,
  XIcon
} from '@shopify/polaris-icons';


interface DeleteButtonProps extends Omit<ButtonProps, 'onClick' | 'children'> {
  onDelete: () => void;
  activator?: ReactNode;
  children?: string
}

export default function DeleteButton(props: DeleteButtonProps) {
  const { onDelete, children, disabled, activator: propsActivator, ...rest } = props
  const [active, setActive] = useState(false);

  const toggleActive = useCallback((state: boolean) => {
    setActive(state)
  }, []);

  const handleDelete = useCallback(() => {
    onDelete()
    toggleActive(false)
  }, [onDelete, toggleActive]);
  const activator = propsActivator
    ? <span onClick={() => toggleActive(disabled && !active ? false : !active)} >{propsActivator}</span>
    : <Button onClick={() => toggleActive(disabled && !active ? false : !active)} {...rest} disabled={disabled}>{children}</Button>

  const actions = [
    { content: 'Yes, Delete', destructive: true, icon: DeleteIcon, onAction: handleDelete },
    { content: 'Cancel', icon: XIcon, onAction: () => toggleActive(false), active: false }
  ]

  return (
    <Popover
      active={active}
      activator={activator}
      onClose={() => toggleActive(false)}
    >
      <ActionList items={actions} />
    </Popover>
  );
}
